function localDay(value) {
  if (!value) return null;
  if (value instanceof Date) return new Date(value.getFullYear(), value.getMonth(), value.getDate());
  const [year, month, day] = String(value).slice(0, 10).split('-').map(Number);
  return year && month && day ? new Date(year, month - 1, day) : null;
}

export function calculateClimateCoverage({ startDate, endDate, validDays = 0 }) {
  const start = localDay(startDate);
  const end = localDay(endDate);
  if (!start || !end || end < start) return { expectedDays: 0, coveredDays: 0, missingDays: 0, percentage: 0 };

  const expectedDays = Math.floor((end - start) / 86400000) + 1;
  const coveredDays = Math.min(expectedDays, Math.max(0, Number(validDays) || 0));
  const missingDays = Math.max(0, expectedDays - coveredDays);
  const percentage = expectedDays > 0 ? Math.round((coveredDays / expectedDays) * 100) : 0;
  return { expectedDays, coveredDays, missingDays, percentage };
}
